exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vdatetime-time-picker {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.vdatetime-time-picker__list {\n  float: left;\n  width: 50%;\n  height: 305px;\n}\n.vdatetime-time-picker__with-suffix .vdatetime-time-picker__list {\n  width: 33.3%;\n}\n.vdatetime-time-picker__item {\n  padding: 10px 0;\n  font-size: 20px;\n  text-align: center;\n  cursor: pointer;\n  -webkit-transition: font-size .3s;\n  transition: font-size .3s;\n}\n.vdatetime-time-picker__item:hover {\n  font-size: 32px;\n}\n.vdatetime-time-picker__item--selected {\n  color: #3f51b5;\n  font-size: 32px;\n}\n.vdatetime-time-picker__item--disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-26ebb208","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/input/vue-datetime/DatetimeTimePicker.vue
// module id = TLIp
// module chunks = 53